import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Login from './account/Login';
import SignUp from './account/SignUp';
import Profile from './account/Profile';
import ProtectedRoute from './account/ProtectedRoute';
import OrdersList from './account/OrdersList';
import AddressBook from './account/AddressBook';
import AccountOverview from './account/AccountOverview';
import EditProfile from './account/EditProfile';


import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Contact from './pages/Contact';

import Cart from './components/Cart/Cart';
import './App.css';
import ProductPage from './components/ProductPage/ProductPage';
import {products} from "./data/product_catalog";
import PlaceOrder from "./account/PlaceOrder";
import ChatWidget from './components/ChatWidget/ChatWidget';
import Notification from './components/Notification/Notification';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/products/:id" element={<ProductPage products={products} />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/account/profile" element={<Profile />} />
              <Route path="/account/orders" element={<OrdersList />} />
              <Route path="/account" element={<AccountOverview />} />
              <Route path="/account/address" element={<AddressBook />} />
              <Route path="/account/profile/edit" element={<EditProfile />} />
              <Route path="/checkout" element={<PlaceOrder />} />
            </Route>
          </Routes>
        </main>
        <ChatWidget />
        <Notification />
        <Footer />
      </div>
    </Router>
  );
}

export default App;

